import { Area, ComposedChart, LabelList, Line, ResponsiveContainer, Scatter, XAxis, YAxis } from 'recharts';

interface XAxisTickProps {
  x?: number;
  y?: number;
  payload?: { value: any };
  index?: number;
  tickLabels?: string[];
  weekColor: string;
  weekFontSize: number;
}

const XAxisTick = (props: XAxisTickProps) => {
  const { x, y, payload, index = 0, tickLabels, weekColor, weekFontSize } = props;
  const label = tickLabels ? tickLabels[index] : payload?.value;
  return (
    <text x={x} y={y} fill={weekColor} fontSize={weekFontSize} textAnchor="middle" dy="0.71em">
      {label}
    </text>
  );
};

XAxisTick.defaultProps = {
  x: 0,
  y: 0,
  payload: undefined,
  index: 0,
  tickLabels: undefined,
};

interface ContractsGraphProps {
  data;
  maxValue;
  ticks?: number[];
  valueFontSize?: number;
  weekFontSize?: number;
  weekColor?: string;
  areaFill?: string;
  lineStrokeWidth?: number;
  dotRadius?: number;
  dotStrokeWidth?: number;
  weekTickMargin?: number;
}

const ContractsGraph = (props: ContractsGraphProps) => {
  const {
    data,
    maxValue,
    ticks,
    valueFontSize,
    weekFontSize,
    weekColor,
    areaFill,
    lineStrokeWidth,
    dotRadius,
    dotStrokeWidth,
    weekTickMargin,
  } = props;

  const isNumericX = data?.[0]?.x !== undefined;
  const tickLabels = isNumericX ? data.filter(d => d.name).map(d => d.name) : undefined;
  const xAxisDomain: [number, number] | undefined = isNumericX ? [0, data.length - 2] : undefined;

  return (
    <ResponsiveContainer width="100%" height="100%" className="contracts-graph">
      <ComposedChart data={data} margin={{ top: 0, left: 0, right: 0, bottom: 0 }}>
        <YAxis reversed dataKey="place" domain={[0, maxValue]} axisLine={false} hide />
        <XAxis
          dataKey={isNumericX ? 'x' : 'name'}
          type={isNumericX ? 'number' : 'category'}
          domain={xAxisDomain}
          ticks={isNumericX ? ticks : undefined}
          axisLine={false}
          tickLine={false}
          interval={0}
          tick={<XAxisTick tickLabels={tickLabels} weekColor={weekColor} weekFontSize={weekFontSize} />}
          tickMargin={weekTickMargin}
        />
        <Area dataKey="place" fill={areaFill} stroke="none" type="monotone" fillOpacity={1} isAnimationActive={false} />
        <Line dataKey="place" stroke="#008C15" type="monotone" strokeWidth={lineStrokeWidth} dot={false} />
        <Scatter
          dataKey="value"
          fill="#008C15"
          shape={<circle cx={5} cy={5} r={dotRadius} fill="#008C15" />}
          fillOpacity={1}
          strokeWidth={dotStrokeWidth}
          stroke="#FFFFFF"
          isAnimationActive={false}
        >
          <LabelList
            dataKey="value"
            position="top"
            style={{
              fontSize: `${valueFontSize}px`,
              fontFamily: 'Montserrat,sans-serif',
              fill: '#fff',
              fontWeight: 'bold',
            }}
            offset={15}
          />
        </Scatter>
      </ComposedChart>
    </ResponsiveContainer>
  );
};

ContractsGraph.defaultProps = {
  ticks: undefined,
  valueFontSize: 24,
  weekFontSize: 14,
  weekColor: '#666',
  areaFill: '#66ba72',
  lineStrokeWidth: 6,
  dotRadius: 10,
  dotStrokeWidth: 3,
  weekTickMargin: 2,
};

export default ContractsGraph;
